import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AssessmentAPI } from 'lib/api/firebase/apis/api-assessment';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export function useAssessmentAPI() {
  const queryClient = useQueryClient();
  const create = useMutation({
    mutationFn: AssessmentAPI.create,
    async onSuccess(_out, variables) {
      await queryClient.invalidateQueries({
        queryKey: queryKeyFactory.assessment.list(variables!.patientId)
      });
    }
  });

  const cancel = useMutation({
    mutationFn: AssessmentAPI.cancel,
    async onSuccess(_out, variables) {
      await queryClient.invalidateQueries({
        queryKey: queryKeyFactory.assessment.list(variables!.patientId)
      });
    }
  });

  const sendAssessmentEmail = useMutation({
    mutationFn: AssessmentAPI.sendAssessmentEmail
  });

  return { create, cancel, sendAssessmentEmail };
}

export function useAssessmentListQuery(patientId: string) {
  return useQuery({
    queryKey: queryKeyFactory.assessment.list(patientId),
    queryFn: () => AssessmentAPI.list({ patientId })
  });
}
